import { jsx as l } from "react/jsx-runtime";
const a = (e) => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ l(
  "path",
  {
    fill: "#212134",
    fillRule: "evenodd",
    d: "M7.1 5a.573.573 0 0 0 0 1.145h9.744a.573.573 0 0 0 0-1.145H7.1Zm10.3 2.354a1.6 1.6 0 0 1 1.6 1.6v8.7a1.6 1.6 0 0 1-1.6 1.6H6.6a1.6 1.6 0 0 1-1.6-1.6V8.963c0-.884.716-1.609 1.6-1.609h10.8Zm-9.834 9.47h9.123l-1.996-2.04-1.14 1.165-2.566-2.622-3.421 3.496Zm7.127-4.078c-.798 0-1.425-.641-1.425-1.457 0-.816.627-1.457 1.425-1.457.799 0 1.426.641 1.426 1.457 0 .816-.627 1.457-1.426 1.457Z",
    clipRule: "evenodd"
  }
) }), m = a;
export {
  m as default
};
